module.exports = __webpack_public_path__ + "static/media/butterfly.b87adf2b.svg";